export function getRate (dividend, divisor) {
  return divisor === 0
    ? 0
    : Math.ceil(dividend / divisor * 100)
}
